// extracted by mini-css-extract-plugin
export var overlay = "TagsMob-module--overlay--2zrk1";
export var container = "TagsMob-module--container--1Egbn";
export var container__tags = "TagsMob-module--container__tags--Bq2vV";
export var fadeIn = "TagsMob-module--fadeIn--XPXlg";
export var fadeOut = "TagsMob-module--fadeOut--33jV0";
export var container__tags__item = "TagsMob-module--container__tags__item--p9Gfc";
export var container__tags__item__button = "TagsMob-module--container__tags__item__button--VAByj";